import CarePlanTaskEditorRow from './CarePlanTaskEditorRow'
import { IconButton, Typography, Box } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { CarePlanModalTask } from './useCarePlanModal'
import type { PatientUser } from '~/shared/types'

interface ITasksFormProps {
  patient: PatientUser
  tasks: CarePlanModalTask[]
  saving: boolean
  addTask: () => void
  updateTask: (i: number, update: Partial<CarePlanModalTask>) => void
  removeTask: (i: number) => void
}

const TasksForm = (props: ITasksFormProps) => {
  const { patient, tasks } = props

  const taskEditorRows = tasks.map((task, i) => {
    const { is_complete } = task
    const disabledRemove = props.saving || is_complete
    const disabledEdit = props.saving || is_complete

    return (
      <Box key={`task_${i}`} sx={{ mb: 3 }}>
        <CarePlanTaskEditorRow
          i={i}
          task={task}
          disabledEdit={disabledEdit}
          disabledRemove={disabledRemove}
          onChange={props.updateTask}
          onRemove={props.removeTask}
          patient={patient}
        />
      </Box>
    )
  })

  const lastTask = tasks.at(-1)
  const editingLastTask = lastTask !== undefined && (!lastTask.title || !lastTask.due_date)
  const disabledAdd = editingLastTask || props.saving

  return (
    <Box sx={{ mt: 3 }}>
      <Typography sx={{ mb: 1 }}>Tasks</Typography>
      {taskEditorRows}
      <IconButton disabled={disabledAdd} onClick={props.addTask} sx={{ p: 0.5 }}>
        <AddIcon />
      </IconButton>
    </Box>
  )
}

export default TasksForm
